export const removeNullAttributes = (payload) => Object.keys(payload).filter((key) => payload[key] !== null)
  .reduce((obj, key) => {
    obj[key] = payload[key];
    return obj;
  }, {});
